var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavbarEmpresa'),_c('EmpresaBanner'),_c('MiInter'),_c('EmpresasAsociadas'),_vm._v(" |"),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }